import { Box, Button, Grid, Typography } from "@mui/material";
import { SubscriptionContext } from "contexts/Subscription";
import { useContext } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { SearchParams } from "schemas/dashboard";
import { Plans } from "schemas/payments";
import { routes } from "schemas/routes";

import StyledVideo from "components/Styled/Video";
import {
  AUTOPILOT_IMAGE_PREVIEW_LINK,
  AUTOPILOT_SUBSCRIPTION_VIDEO_LINK,
  PRO_IMAGE_PREVIEW_LINK,
  PRO_SUBSCRIPTION_VIDEO_LINK,
  VA_IMAGE_PREVIEW_LINK,
  VA_SUBSCRIPTION_VIDEO_LINK,
} from "constants/influencer";

// Mobile app deep link
const MOBILE_APP_SCHEME = "onbento://";

const SuccessPage = () => {
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const planName = searchParams.get(SearchParams.PLAN_NAME);
  const fromSubscribePage =
    searchParams.get(SearchParams.FROM_SUBSCRIBE_PAGE) === "true";
  const { setUpgradeDialogSource } = useContext(SubscriptionContext);

  const isVa = planName === Plans.VA_YEARLY || planName === Plans.VA;
  const isAutopilot =
    planName === Plans.AUTOPILOT || planName === Plans.AUTOPILOT_YEARLY;
  const isYearly =
    planName === Plans.PRO_YEARLY ||
    planName === Plans.VA_YEARLY ||
    planName === Plans.AUTOPILOT_YEARLY;
  const isOnboarding = searchParams.get("isOnboarding") === "true";

  const navigate = useNavigate();

  const goBack = () => {
    if (fromSubscribePage) {
      window.location.href = `${MOBILE_APP_SCHEME}subscription-success`;
      return;
    }
    if (isOnboarding) {
      navigate(`/${routes.aboutOnboarding}${location.search}`, {
        replace: true,
      });
      setUpgradeDialogSource(null);
      return;
    }
    if (isAutopilot) {
      navigate(`/${routes.autopilot}`);
      return;
    }
    navigate(`/${routes.settings}`);
    setUpgradeDialogSource(null);
  };

  const getTitle = () => {
    if (isOnboarding) {
      return "Complete Onboarding";
    } else if (fromSubscribePage) {
      return "Back to App";
    } else {
      return "Go to Dashboard";
    }
  };

  return (
    <Grid
      item
      xs
      container
      alignItems="center"
      justifyContent={"center"}
      sx={{
        backgroundColor: "green.dark",
        position: "absolute",
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
      }}
    >
      <Box
        sx={{
          backgroundColor: { xs: "none", md: "green.main" },
          p: { xs: 2, md: 10 },
          borderRadius: 4,
          textAlign: "center",
        }}
      >
        <Typography
          variant="h4"
          textAlign="center"
          sx={{ mb: 3, color: "white" }}
        >
          🎉 Thanks for subscribing to Bento
        </Typography>

        <Box sx={{ mb: 3 }}>
          <StyledVideo
            image={
              isVa
                ? VA_IMAGE_PREVIEW_LINK
                : isAutopilot
                  ? AUTOPILOT_IMAGE_PREVIEW_LINK
                  : PRO_IMAGE_PREVIEW_LINK
            }
            videoPreview={
              isVa
                ? VA_IMAGE_PREVIEW_LINK
                : isAutopilot
                  ? AUTOPILOT_IMAGE_PREVIEW_LINK
                  : PRO_IMAGE_PREVIEW_LINK
            }
            link={
              isVa
                ? VA_SUBSCRIPTION_VIDEO_LINK
                : isAutopilot
                  ? AUTOPILOT_SUBSCRIPTION_VIDEO_LINK
                  : PRO_SUBSCRIPTION_VIDEO_LINK
            }
            title={`Make the Most of Your ${
              isVa ? "Virtual Assistant" : isAutopilot ? "Autopilot" : "Pro"
            } Subscription`}
            widthPercentage={isVa || isAutopilot ? 100 : 30}
            previewHeight={
              isAutopilot ? { xs: 200, lg: 250 } : { xs: 300, lg: 400 }
            }
            dialogMaxWidth={1000}
          />
        </Box>

        {isYearly && (
          <Typography textAlign="center" sx={{ color: "white" }}>
            Keep an eye on your inbox — we'll send you a special promo code for{" "}
            <strong>one free template</strong> purchase.
            <br />
            We can't wait to see what you'll build. 💜
          </Typography>
        )}

        <Grid item container justifyContent="center" sx={{ mt: 3 }}>
          <Button onClick={goBack} sx={{ color: "yellow.main" }}>
            {getTitle()}
            <Box
              component="i"
              className="fa-solid fa-arrow-right"
              sx={{ ml: 1 }}
            />
          </Button>
        </Grid>
      </Box>
    </Grid>
  );
};

export default SuccessPage;
